import { render, staticRenderFns } from "./UpdateRoundTime.vue?vue&type=template&id=96b56262&"
import script from "./UpdateRoundTime.vue?vue&type=script&lang=js&"
export * from "./UpdateRoundTime.vue?vue&type=script&lang=js&"
import style0 from "./UpdateRoundTime.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports